import React from 'react'
import SubServiceImageUpload from './SubServiceImageUpload'

function FeedbackPage() {
  return (
    <div>
      <SubServiceImageUpload/>
    </div>
  )
}

export default FeedbackPage
